import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import toast from "react-hot-toast";
import { s3Upload } from "../../../Utils/s3Upload";

const ESignatureStep = ({
  signature,
  setSignature,
  isAutofilled,
  onBack,
  onContinue,
}) => {
  const sigRef = useRef();
  const [activeTab, setActiveTab] = useState("draw");
  const [signaturePreview, setSignaturePreview] = useState(signature || null);
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [uploading, setUploading] = useState(false);

  // Save drawn signature (as base64)
  const handleSaveDraw = () => {
    if (!sigRef.current || sigRef.current.isEmpty()) {
      return toast.error("Please draw your signature");
    }
    const dataUrl = sigRef.current.toDataURL("image/png");
    setSignaturePreview(dataUrl);
    setSignatureUrl(dataUrl);        // For draw, we send base64 directly
    setSignature(dataUrl);           // Keep original prop behavior
    toast.success("Signature saved");
  };

  // Upload signature image to S3 (folder: signatures)
  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const localPreview = URL.createObjectURL(file);
    setSignaturePreview(localPreview);

    setUploading(true);
    const uploadToast = toast.loading("Uploading signature...");

    try {
      const res = await s3Upload(file, "signatures");
      setSignatureUrl(res.url);
      setSignature(res.url);
      toast.dismiss(uploadToast);
      toast.success("Signature uploaded successfully");
    } catch (error) {
      console.error(error);
      toast.dismiss(uploadToast);
      toast.error("Failed to upload signature");
      setSignaturePreview(null);
    } finally {
      setUploading(false);
    }
  };

  // Clear canvas
  const clearCanvas = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
  };

  return (
    <div className="space-y-5 pt-5 sm:py-5">

      {/* Header */}
      <div className="text-center sm:text-left">
        <h2 className="text-lg font-semibold text-gray-900">
          {isAutofilled ? "Verify Your Signature" : "Add Your E-Signature"}
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          {isAutofilled
            ? "Your digital signature is auto-fetched from your other role profile."
            : "This signature is required to complete your registration"}
        </p>
      </div>

      {isAutofilled ? (
        <div className="border-2 border-gray-200 rounded-2xl bg-white overflow-hidden shadow-sm p-6 text-center flex flex-col items-center justify-center min-h-[12rem] relative">
          <img
            src={signature}
            alt="Auto-fetched signature"
            className="h-24 object-contain mx-auto"
          />
         
        </div>
      ) : (
        <>
          {/* Tabs */}
          <div className="flex gap-3">
            <button
              onClick={() => setActiveTab("draw")}
              className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition ${activeTab === "draw"
                ? "bg-primaryColor text-white shadow"
                : "bg-gray-100 text-gray-600"
                }`}
            >
              Draw
            </button>

            <button
              onClick={() => setActiveTab("upload")}
              className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition ${activeTab === "upload"
                ? "bg-primaryColor text-white shadow"
                : "bg-gray-100 text-gray-600"
                }`}
            >
              Upload
            </button>
          </div>

          {/* DRAW CANVAS */}
          {activeTab === "draw" && (
            <div className="border-2 border-gray-200 rounded-2xl bg-white overflow-hidden shadow-sm">
              <SignatureCanvas
                ref={sigRef}
                penColor="black"
                canvasProps={{
                  className: "w-full h-40",
                }}
              />

              <div className="flex justify-between px-4 py-3 border-t bg-gray-50">
                <button
                  onClick={clearCanvas}
                  className="text-sm text-gray-500"
                >
                  Clear
                </button>

                <button
                  onClick={handleSaveDraw}
                  className="text-sm font-medium text-primaryColor"
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {/* UPLOAD */}
          {activeTab === "upload" && (
            <div className="border-2 border-dashed border-gray-300 rounded-2xl p-6 text-center bg-white">
              <input
                type="file"
                accept="image/*"
                onChange={handleUpload}
                className="hidden"
                id="signatureUpload"
                disabled={uploading}
              />

              <label
                htmlFor="signatureUpload"
                className="cursor-pointer flex flex-col items-center gap-2"
              >
                <span className="text-3xl">📤</span>
                <span className="text-sm font-medium text-gray-700">
                  {uploading ? "Uploading..." : "Click to upload or open camera"}
                </span>
                <span className="text-xs text-gray-400">
                  PNG, JPG supported
                </span>
              </label>
            </div>
          )}

          {/* Preview */}
          {signaturePreview && (
            <div className="bg-white border rounded-xl p-3">
              <p className="text-xs text-gray-500 mb-2">Preview</p>
              <img
                src={signaturePreview}
                alt="signature"
                className="h-20 border rounded mx-auto"
              />
            </div>
          )}
        </>
      )}

      {/* Buttons (same style as address step) */}
      <div className="flex flex-col sm:flex-row gap-3 mt-6 pb-4">
        <button
          onClick={onBack}
          className="flex-1 border-2 border-gray-200 text-gray-600 py-3.5 rounded-xl font-medium text-sm hover:border-primaryColor hover:text-primaryColor transition"
        >
          Back
        </button>

        <button
          onClick={() => {
            if (!isAutofilled && !signatureUrl && !signature) {
              return toast.error("Please add your signature");
            }
            onContinue();
          }}
          className="flex-1 bg-primaryColor text-white py-3.5 rounded-xl font-semibold text-sm shadow-md"
        >
          {isAutofilled ? "Confirm & Continue" : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default ESignatureStep;
















// import React, { useRef, useState } from "react";
// import SignatureCanvas from "react-signature-canvas";
// import toast from "react-hot-toast";

// const ESignatureStep = ({
//   signature,
//   setSignature,
//   onBack,
//   onContinue,
// }) => {
//   const sigRef = useRef();
//   const [activeTab, setActiveTab] = useState("draw");

//   // Save drawn signature
//   const handleSaveDraw = () => {
//     if (!sigRef.current || sigRef.current.isEmpty()) {
//       return toast.error("Please draw your signature");
//     }
//     const dataUrl = sigRef.current.toDataURL("image/png");
//     setSignature(dataUrl);
//     toast.success("Signature saved");
//   };

//   // Upload image
//   const handleUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setSignature(reader.result);
//       toast.success("Signature uploaded");
//     };
//     reader.readAsDataURL(file);
//   };

//   return (
//     <div className="space-y-5 pt-5 sm:py-5">

//       {/* Header */}
//       <div className="text-center sm:text-left">
//         <h2 className="text-lg font-semibold text-gray-900">
//           Add Your E-Signature
//         </h2>
//         <p className="text-sm text-gray-500 mt-1">
//           This signature is required to complete your registration
//         </p>
//       </div>

//       {/* Tabs */}
//       <div className="flex gap-3">
//         <button
//           onClick={() => setActiveTab("draw")}
//           className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition ${activeTab === "draw"
//             ? "bg-primaryColor text-white shadow"
//             : "bg-gray-100 text-gray-600"
//             }`}
//         >
//           Draw
//         </button>

//         <button
//           onClick={() => setActiveTab("upload")}
//           className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition ${activeTab === "upload"
//             ? "bg-primaryColor text-white shadow"
//             : "bg-gray-100 text-gray-600"
//             }`}
//         >
//           Upload
//         </button>
//       </div>

//       {/* DRAW CANVAS */}
//       {activeTab === "draw" && (
//         <div className="border-2 border-gray-200 rounded-2xl bg-white overflow-hidden shadow-sm">
//           <SignatureCanvas
//             ref={sigRef}
//             penColor="black"
//             canvasProps={{
//               className: "w-full h-40",
//             }}
//           />

//           <div className="flex justify-between px-4 py-3 border-t bg-gray-50">
//             <button
//               onClick={() => sigRef.current.clear()}
//               className="text-sm text-gray-500"
//             >
//               Clear
//             </button>

//             <button
//               onClick={handleSaveDraw}
//               className="text-sm font-medium text-primaryColor"
//             >
//               Save
//             </button>
//           </div>
//         </div>
//       )}

//       {/* UPLOAD */}
//       {activeTab === "upload" && (
//         <div className="border-2 border-dashed border-gray-300 rounded-2xl p-6 text-center bg-white">
//           <input
//             type="file"
//             accept="image/*"
//             onChange={handleUpload}
//             className="hidden"
//             id="signatureUpload"
//           />

//           <label
//             htmlFor="signatureUpload"
//             className="cursor-pointer flex flex-col items-center gap-2"
//           >
//             <span className="text-3xl">📤</span>
//             <span className="text-sm font-medium text-gray-700">
//               Click to upload or open camera
//             </span>
//             <span className="text-xs text-gray-400">
//               PNG, JPG supported
//             </span>
//           </label>
//         </div>
//       )}

//       {/* Preview */}
//       {signature && (
//         <div className="bg-white border rounded-xl p-3">
//           <p className="text-xs text-gray-500 mb-2">Preview</p>
//           <img
//             src={signature}
//             alt="signature"
//             className="h-20 border rounded"
//           />
//         </div>
//       )}

//       {/* Buttons (same style as address step) */}
//       <div className="flex flex-col sm:flex-row gap-3 mt-6 pb-4">
//         <button
//           onClick={onBack}
//           className="flex-1 border-2 border-gray-200 text-gray-600 py-3.5 rounded-xl font-medium text-sm hover:border-primaryColor hover:text-primaryColor transition"
//         >
//           Back
//         </button>

//         <button
//           onClick={() => {
//             if (!signature) {
//               return toast.error("Please add your signature");
//             }
//             onContinue();
//           }}
//           className="flex-1 bg-primaryColor text-white py-3.5 rounded-xl font-semibold text-sm shadow-md"
//         >
//           Continue
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ESignatureStep;